import { showDeleteConfirmation } from '@modules/common';
import { switchMap, tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { Session } from '@modules/auth/session';
import { R } from '@core/utils/r';
import { FiltersAPI } from '@business/api/filters';
import { FilterResponse } from '@business/entities/filter';

export class FilterBloc extends BaseBloc {
  private readonly filterRepo = new Repository<FilterResponse>({
    getItemId: filter => filter.id,
  });

  readonly filters$ = this.filterRepo.items$;
  readonly selectFilter$ = this.filterRepo.selectItem;

  onReset() {
    this.filterRepo.reset();
  }

  fetchFilters = () => {
    return FiltersAPI.fetchFilters().pipe(this.filterRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_general_error') }));
  };

  createFilter = (filter: Partial<FilterResponse>) => {
    return FiltersAPI.createFilter(filter).pipe(
      this.filterRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_filter'),
      }),
    );
  };

  updateFilter = (id: string, filter: Partial<FilterResponse>) => {
    return FiltersAPI.updateFilter(id, filter).pipe(
      this.filterRepo.ops.upsertOne(item => ({ item })),
      tap(() => Session.reloadUser().subscribe()),
      handleMessage({
        type: requestMessage('update_filter'),
      }),
    );
  };

  deleteFilter = (filterId: string) => {
    return showDeleteConfirmation('Delete Filter', 'Do you really want to remove this filter?').pipe(
      switchMap(() => FiltersAPI.deleteFilter(filterId)),

      this.filterRepo.ops.removeOne(() => filterId),
      handleMessage({
        type: requestMessage('delete_filter'),
      }),
    );
  };
}
